export default __webpack_public_path__ + "static/media/calasalada.79a8a7f3.jpg";